import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
} from 'react-router-dom'
import ReactGA from 'react-ga4'
import { Location } from 'history'
import {
  Dashboard,
  Login,
  NoMatch,
  Verify,
  Create,
  CreateTeacher,
  Update,
} from 'pages'
import { PrivateRoute } from 'router'
import { Providers, useAuth } from '../providers'
import { Profile } from 'pages/Profile'
import { OnboardingModal } from 'components/OnboardingModal/OnboardingModal'
import * as access from 'types/access'
import { SingleVideo } from 'videoReview/pages'

type LocationState = {
  create?: Location
  edit?: Location
}

const env = process.env.NODE_ENV
const GA_ID: string | undefined =
  process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID
if (GA_ID)
  ReactGA.initialize(GA_ID, {
    testMode: env === 'test',
  })

function AppSwitch() {
  const location = useLocation<LocationState>()

  const { hasAccess } = useAuth()
  return (
    <>
      <OnboardingModal />
      <Switch location={location}>
        <PrivateRoute
          exact
          path="/"
          checkAccess={() =>
            !hasAccess(access.Groups.DASHBOARD, access.Dashboard.LIST_USERS)
              ? '/profile'
              : null
          }
          component={Dashboard}
        />
        <PrivateRoute exact path="/profile" component={Profile} />
        <PrivateRoute exact path="/teacher/new" component={CreateTeacher} />
        <PrivateRoute exact path="/student/new" component={Create} />
        <PrivateRoute exact path="/user/:id" component={Update} />
        <PrivateRoute exact path="/video/:videoId" component={SingleVideo} />
        <Route
          path="/help"
          component={() => {
            window.location.href = 'https://help.tm.community/teachers/en'
            return null
          }}
        />
        <Route path="/login" component={Login} />
        <Route exact path="/verify" component={Verify} />
        <Route exact path="/verify/:code" component={Verify} />
        <Route>
          <NoMatch />
        </Route>
      </Switch>
    </>
  )
}

function App() {
  return (
    <Router>
      <Providers>
        <AppSwitch />
      </Providers>
    </Router>
  )
}

export default App
